export const modal = () => {
  document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("js-modal-item");
    // const modalImgElement = modal.querySelector("img");
    const modalBtns = document.querySelectorAll(".js-modal-target");
    const modalCloseBtns = document.querySelectorAll(".js-modal-close");
    const modalCloseBtnsBg = document.querySelectorAll(".js-modal-close-bg");
    const video = document.getElementById("modalVideo");
    const pageTopBtn = document.getElementById("js-pageTop");

    const body = document.body;

    // modal open
    modalBtns.forEach((modalBtn) => {
      modalBtn.addEventListener("click", function () {
        // const imgElement = this.querySelector("img");
        // const imgSrc = imgElement.getAttribute("src"); // src 属性を取得
        // const parentElement = this.parentElement;
        // body.classList.remove("is-header-show");
        // pageTopBtn.classList.remove("is-show");
        // modalImgElement.setAttribute("src", imgSrc);
        modal.classList.toggle("is-modal-active");
        body.classList.toggle("is-lock");
        video.play(); // 動画を再生
      });
    });

    // modal close
    modalCloseBtns.forEach((modalCloseBtn) => {
      modalCloseBtn.addEventListener("click", function () {
        const parentElement = this.closest("#js-modal-item");
        parentElement.classList.toggle("is-modal-active");
        body.classList.toggle("is-lock");
        video.pause(); // 動画を一時停止
        video.currentTime = 0; // 動画をリセット
      });
    });

    // modal closeBg
    modalCloseBtnsBg.forEach((modalCloseBtnBg) => {
      modalCloseBtnBg.addEventListener("click", function () {
        const parentElement = this.closest("#js-modal-item");
        parentElement.classList.toggle("is-modal-active");
        body.classList.toggle("is-lock");
        video.pause(); // 動画を一時停止
        video.currentTime = 0; // 動画をリセット
      });
    });
  });
};
